export default __webpack_public_path__ + "static/media/iam_background_xl1.81102130.jpg";